// src/pages/OnlineTickets/index.js
import React from "react";
import styled from "styled-components";
import { FaSearch } from 'react-icons/fa';
import { MdQrCodeScanner } from 'react-icons/md';
import { FaListCheck } from 'react-icons/fa6';
import { FaCheckCircle } from 'react-icons/fa';


const OnlineTickets = () => {
    return (
        <Wrapper>
            <div className="container d-flex justify-content-center align-items-center vh-100">
                <div className="card shadow p-4" style={{ maxWidth: "400px", width: "100%" }}>
                    <h4 className="text-center mb-3 text-dark">Verify Ticket</h4>
                    <p className="text-center text-muted mb-4">
                        Enter Ticket ID or scan QR code to verify its validity.
                    </p>
                    <label className="form-label fw-bold">Ticket ID</label>
                    <div className="d-flex gap-3 mb-3">
                        <input
                            type="text"
                            className="form-control bg-light"
                            placeholder="Enter Ticket ID (e.g., ACTIVE123)"
                        />
                        <button className="btn btn-primary d-flex align-items-center gap-2">
                            <FaSearch />
                            Verify
                        </button>
                    </div>
                    <div className="d-flex align-items-center my-3 text-muted">
                        <div style={{ flex: 1, height: '1px', backgroundColor: '#ced4da' }}></div>
                        <div className="px-3">OR</div>
                        <div style={{ flex: 1, height: '1px', backgroundColor: '#ced4da' }}></div>
                    </div>
                    <button className="btn btn-outline-secondary w-100 mb-3 text-muted qr-scan-btn">
                        <MdQrCodeScanner size={20} className="me-2" />
                        Scan QR Code
                    </button>
                    <p className="text-muted text-center" style={{ fontSize: "0.85rem" }}>
                        Ensure you have good lighting when scanning QR codes.
                    </p>
                </div>
            </div>


            <div className="container d-flex justify-content-center align-items-center py-5">
                <div className="card shadow p-4" style={{ maxWidth: "400px", width: "100%" }}>

                    <div className="d-flex align-items-center mb-2">
                        <FaListCheck className="me-2 text-dark" />
                        <h6 className="mb-0 fw-bold text-dark">Recent Verifications</h6>
                    </div>

                    <p className="text-muted mb-3" style={{ fontSize: "0.9rem" }}>
                        Last 1 ticket(s) verified in this session.
                    </p>
                    <div className="border rounded px-3 py-2 bg-light">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                            <span className="fw-bold text-primary">
                                ACTIVE123 - Mountain View Peak
                            </span>
                            <span
                                className="badge bg-warning text-dark"
                                style={{ fontSize: "0.75rem" }}
                            >
                                Used
                            </span>
                        </div>
                        <div className="text-muted" style={{ fontSize: "0.85rem" }}>
                            Customer: Alice Wonderland (555-0101)
                            <br />
                            Verified: 10:32:36 AM
                        </div>
                    </div>

                </div>
            </div>

            {/* card 1 active  */}
            <div className="container d-flex justify-content-center align-items-center py-5">
                <div className="card shadow p-4" style={{ maxWidth: "400px", width: "100%" }}>
                    <h4 className="text-center mb-3 text-dark">Verify Ticket</h4>
                    <p className="text-center text-muted mb-4">
                        Enter Ticket ID or scan QR code to verify its validity.
                    </p>
                    <label className="form-label fw-bold">Ticket ID</label>
                    <div className="d-flex gap-3 mb-3">
                        <input
                            type="text"
                            className="form-control bg-light"
                            placeholder="Enter Ticket ID (e.g., ACTIVE123)"
                        />
                        <button className="btn btn-primary d-flex align-items-center gap-2">
                            <FaSearch />
                            Verify
                        </button>
                    </div>
                    <div className="d-flex align-items-center my-3 text-muted">
                        <div style={{ flex: 1, height: '1px', backgroundColor: '#ced4da' }}></div>
                        <div className="px-3">OR</div>
                        <div style={{ flex: 1, height: '1px', backgroundColor: '#ced4da' }}></div>
                    </div>
                    <button className="btn btn-outline-secondary w-100 mb-3 text-muted qr-scan-btn">
                        <MdQrCodeScanner size={20} className="me-2" />
                        Scan QR Code
                    </button>
                    <p className="text-muted text-center" style={{ fontSize: "0.85rem" }}>
                        Ensure you have good lighting when scanning QR codes.
                    </p>

                    <div className="border rounded p-3" style={{ backgroundColor: '#e6f9ec', maxWidth: '400px' }}>
                        {/* Header: Status Transition */}
                        <div className="d-flex align-items-center text-success fw-semibold mb-2">
                            <FaCheckCircle className="me-2" />
                            Active → Used 
                        </div>

                        {/* Message */}
                        <p className="text-muted mb-3" style={{ fontSize: '0.9rem' }}>
                            Ticket <strong>ACTIVE123</strong> was Active and has been marked as Used.
                        </p>

                        {/* Ticket Info */}
                        <div className="text-dark" style={{ fontSize: '0.9rem' }}>
                            <div><strong>ID:</strong> VALID123</div>
                            <div><strong>Spot:</strong> Mountain View Peak</div>
                            <div><strong>Customer:</strong> Alice Wonderland</div>
                            <div><strong>Quantity:</strong> 2</div>
                            <div><strong>Event Date:</strong> 2024-08-01</div>
                        </div>

                        {/* Status Badge */}
                        <div className="mt-3">
                            <span className="badge bg-success">Status: Valid</span>
                        </div>
                    </div>
                </div>
            </div>
        
            <div className="container d-flex justify-content-center align-items-center py-5">
                <div className="card shadow p-4" style={{ maxWidth: "400px", width: "100%" }}>
                    <h4 className="text-center mb-3 text-dark">Verify Ticket</h4>
                    <p className="text-center text-muted mb-4">
                        Enter Ticket ID or scan QR code to verify its validity.
                    </p>
                    <label className="form-label fw-bold">Ticket ID</label>
                    <div className="d-flex gap-3 mb-3">
                        <input
                            type="text"
                            className="form-control bg-light"
                            placeholder="Enter Ticket ID (e.g., ACTIVE123)"
                        />
                        <button className="btn btn-primary d-flex align-items-center gap-2">
                            <FaSearch />
                            Verify
                        </button>
                    </div>
                    <div className="d-flex align-items-center my-3 text-muted">
                        <div style={{ flex: 1, height: '1px', backgroundColor: '#ced4da' }}></div>
                        <div className="px-3">OR</div>
                        <div style={{ flex: 1, height: '1px', backgroundColor: '#ced4da' }}></div>
                    </div>
                    <button className="btn btn-outline-secondary w-100 mb-3 text-muted qr-scan-btn">
                        <MdQrCodeScanner size={20} className="me-2" />
                        Scan QR Code
                    </button>
                    <p className="text-muted text-center" style={{ fontSize: "0.85rem" }}>
                        Ensure you have good lighting when scanning QR codes.
                    </p>



                    <div className="border rounded p-3" style={{ backgroundColor: '#fff3cd', maxWidth: '400px', width: '100%' }}>
                        {/* Header: Status Transition */}
                        <div className="d-flex align-items-center text-warning fw-semibold mb-2">
                            <FaCheckCircle className="me-2" />
                            Used
                        </div>

                        {/* Message */}
                        <p className="text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                            Ticket is already used
                        </p>

                        <hr className="my-2" />

                        {/* Ticket Info */}
                        <div style={{ fontSize: '0.9rem' }}>
                            <div className="text-muted"><strong className="text-dark">ID:</strong> ACTIVE123</div>
                            <div className="text-muted"><strong className="text-dark">Spot:</strong> Mountain View Peak</div>

                            <div className="mt-2">
                                <strong className="text-dark">Customer Details:</strong><br />
                                <span className="text-dark">Alice Wonderland</span><br />
                                <span className="text-muted">555-0101</span>
                            </div>

                            <div className="mt-2 text-muted"><strong className="text-dark">Quantity:</strong> 2</div>
                            <div className="text-muted"><strong className="text-dark">Visit Date:</strong> 01 Aug 2024</div>
                        </div>

                        {/* Status Badge */}
                        <div className="mt-3">
                            <span
                                className="badge text-dark"
                                style={{ backgroundColor: '#f0ad4e', fontSize: '0.8rem' }}
                            >
                                Current Status: Used
                            </span>
                        </div>
                    </div>
                </div>
            </div>


        </Wrapper>
    );
};

export default OnlineTickets;

const Wrapper = styled.div`
 
.card.p-3.shadow-sm.border-0.mb-3 {
    background-color: #fafafa;
}
.qr-scan-btn:hover {
  background-color: #f8f9fa; /* light grey on hover */
  color: #6c757d !important; /* maintain muted text color */
  border-color: #ced4da;     /* subtle border */
}

  
  
`;